import LongTouch from './LongTouch';

LongTouch.install = function(Vue) {
  Vue.component(LongTouch.name, LongTouch);
};

export default LongTouch;
